import type { AdditionalHts } from '@xbcb/api-gateway-client';
import { formatHTS } from '@xbcb/hts-client-utils';
import { isSection301, isSection232 } from './arrayHelpers';
import { AdditionalHtsType } from '@xbcb/trade-data-types';
import { getEnv } from '@xbcb/ui-env';
import { UiStage } from '@xbcb/ui-types';

export const isAdditionalHtsApplicable = (
  additionalHts: AdditionalHts,
  removedTariffs: string[] = [],
): boolean => {
  const { stage } = getEnv();
  if (!additionalHts?.type) {
    return false;
  }
  if (removedTariffs.includes(formatHTS(additionalHts.number))) {
    return false;
  }
  if (
    // Special cases for reciprocal tariffs, which are hopefully temporary.
    // In general we can't assume that section 232 tariffs can be auto-added
    [
      AdditionalHtsType.IEEPA_FENTANYL,
      AdditionalHtsType.RECIPROCAL_POLICY,
      AdditionalHtsType.RECIPROCAL_POLICY_EXCLUSION,
      AdditionalHtsType.SECTION_232_AUTO_PARTS,
    ].includes(additionalHts.type as AdditionalHtsType) &&
    // Pending ops sign off on https://app.asana.com/1/8442528107068/project/1210150806086495/task/1209517261829877
    stage !== UiStage.PROD
  ) {
    return true;
  }
  // Requested by ops as part of https://app.asana.com/1/8442528107068/project/1210150806086495/task/1209517261829877
  if (stage !== UiStage.PROD && isSection232(additionalHts.type)) {
    return true;
  }
  return (
    isSection301(additionalHts.type) &&
    // This section has been indefinitely suspended. Remove this check
    // if it goes live (https://ustr.gov/about-us/policy-offices/press-office/press-releases/2019/december/united-states-and-china-reach)
    !['section301List4B', 'SECTION_301_LIST_4B'].includes(additionalHts.type)
  );
};
